import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleTheme } from 'src/store/slices/theme';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import './index.scss';

export const FloatingThemeToggle: React.FC = () => {
  const dispatch = useDispatch();
  const themeMode = useSelector((state: any) => state.theme?.mode || 'light');

  const handleToggle = () => {
    dispatch(toggleTheme());
  };

  return (
    <div
      className="floating-theme-toggle"
      onClick={handleToggle}
      role="button"
      tabIndex={0}
      aria-label={`Switch to ${themeMode === 'light' ? 'dark' : 'light'} mode`}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggle();
        }
      }}
    >
      {themeMode === 'light' ? (
        <DarkModeIcon width="20" height="20" />
      ) : (
        <LightModeIcon width="20" height="20" />
      )}
    </div>
  );
};

